import KYCBenefitValue from './KYCBenefitValue'
import { Container, KeyText } from './KYCBenefitRow.styles'

export type KYCBenefitRowProps = {
    keyName: string
    value: string | boolean | number
    unit?: string
    unitPosition?: 'left' | 'right'
    isCurrency?: boolean
}

const KYCBenefitRow = ({
    keyName,
    value,
    unit,
    unitPosition,
    isCurrency
}: KYCBenefitRowProps) => {
    return (
        <Container>
            <KeyText>
                {keyName}
            </KeyText>
            <KYCBenefitValue
                value={value}
                unit={unit}
                unitPosition={unitPosition}
                isCurrency={isCurrency}
            />
        </Container>
    )
}

export default KYCBenefitRow
